import React from 'react'

import TextInput from '~mizuno/client/components/molecules/TextInput'

export default (props) => <TextInput {...props} />
